import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import Participant from '@/store/participant';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    modules: ['participant'],
});

export const store = new Vuex.Store({
    state: {},
    modules: {
        participant: Participant,
    },
    plugins: [vuexLocal.plugin],
});
